import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";

interface ReviewRow {
  secondPart: string;
  userTerm: string | null;
  correct: boolean;
}

interface QuizReviewMatchingProps {
  rows: ReviewRow[];
}

function matchingRowFrameColor(correct: boolean): string {
  if (correct) return "border-success bg-success-light";
  return "border-error bg-error-light";
}

function assignedTermFontColor(correct: boolean): string {
  if (correct) return "text-success-foreground";
  return "text-error-foreground";
}

/**
 * Review rows for a matching (Zuordnung) question — used after the learner
 * submits, to show each description with the assigned term.
 */
const QuizReviewMatching = ({ rows }: QuizReviewMatchingProps) => (
  <div className="flex flex-col gap-3">
    {rows.map((row, index) => (
      <div
        key={index}
        className={cn(
          "flex flex-col gap-3 rounded-xl border-2 p-4 sm:flex-row sm:items-center",
          matchingRowFrameColor(row.correct)
        )}
      >
        <div className="prose prose-p:inline max-w-full flex-1 text-primary">
          <CourseMarkdown>{row.secondPart}</CourseMarkdown>
        </div>

        <ArrowRight className="hidden h-4 w-4 shrink-0 text-muted-foreground sm:block" />

        <span
          className={cn(
            "shrink-0 font-semibold sm:w-56",
            assignedTermFontColor(row.correct)
          )}
        >
          {row.userTerm ?? "—"}
        </span>
      </div>
    ))}
  </div>
);

export default QuizReviewMatching;
